import { AnalyticsDashboard } from '../features/analytics';

export default function AnalyticsPage() {
  return (
    <div className="mx-auto max-w-7xl p-6">
      <AnalyticsDashboard />
    </div>
  );
}
